module.exports = __webpack_public_path__ + "static/machine02-sq-1d075454d52902c8803ffa390d918da6.png";